import { render, staticRenderFns } from "./AccountVerificationPage.vue?vue&type=template&id=09b706b4&"
import script from "./AccountVerificationPage.vue?vue&type=script&lang=ts&"
export * from "./AccountVerificationPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b706b4')) {
      api.createRecord('09b706b4', component.options)
    } else {
      api.reload('09b706b4', component.options)
    }
    module.hot.accept("./AccountVerificationPage.vue?vue&type=template&id=09b706b4&", function () {
      api.rerender('09b706b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/AccountVerificationPage.vue"
export default component.exports